
















































import { Component, Prop, Vue } from "vue-property-decorator";
import { vxm } from "@/store.vuex";
import CandidateCard from "./CandidateCard.vue";
import { REFERRAL_STATUS } from "./constants";

@Component({
  components: {
    CandidateCard,
  },
})
export default class CandidateList extends Vue {
  @Prop() friendReferral;
  private referralStatus = REFERRAL_STATUS;

  private statusTextMapping: any = {};
  getStatus(status, defaultText) {
    return this.statusTextMapping[status] || defaultText;
  }

  getUsersByStatus(jobStatus) {
    const userReferralDetail =
      vxm.referrals.getJobReferralDetails.userReferralDetail;
    return (
      (userReferralDetail &&
        userReferralDetail.referredUserList.filter(
          (user: any) => user && user.userJobStatus === jobStatus
        )) ||
      []
    );
  }
  get hasDataToShow() {
    const userReferralDetail =
      vxm.referrals.getJobReferralDetails.userReferralDetail;
    return (
      userReferralDetail &&
      userReferralDetail.referredUserList.find(
        (user: any) =>
          user &&
          !!this.referralStatus.find(
            (status) => status.code === user.userJobStatus
          )
      )
    );
  }
  get referredUserList() {
    return (
      vxm.referrals.getJobReferralDetails.userReferralDetail.referredUserList ||
      []
    );
  }

  get hasfriendReferrals() {
    return !!this.referredUserList.length;
  }

  mounted() {
    this.statusTextMapping = {
      '90': this.$t('myreferrals.hired'),
      '50': this.$t('myreferrals.offered'),
      '10': this.$t('myreferrals.applied'),
      '00': this.$t('myreferrals.signedup'),
      '-10': this.$t('myreferrals.referred'),
    };
  }
}
